/*@ngInject*/
const FieldReferencesController = function ($rootScope, $scope, $state, options, configurationMediator, localization, coreConstant, navigationStateModel) {

    localization.getTranslationsByKeys([this.translationsKey, 'fieldReferences']).then(function (translations) {

        $scope.viewModel = {
            title: options.title,
            cancelButton: options.cancelButtonLabel,
            okButton: options.confirmButtonLabel,
            buttonClass: options.showConfirmationButtons ? 'btn-success' : '',
            fieldReferencesMessage: options.summary,
            displayTypeColumn: false,
            fieldReferenceList: options.fieldReferenceList,
            fieldParams: {
                key: 'name',
                sortType: 'asc'
            }
        };

        $scope.onSort = function (event, params) {
            $scope.viewModel.fieldParams = params;
            $scope.viewModel.fieldReferenceList = _.orderBy($scope.viewModel.fieldReferenceList, [params.key], [params.sortType]);
        };

        $scope.getType = function (type) {
            return translations.type[type];
        };

        $scope.onConfirm = function () {
            $scope.$close(true);
        };

        $scope.onCancel = function () {
            $scope.$close(false);
        };

        $scope.openFormTemplate = function (referenceUri) {
            var referenceArray = _.split(referenceUri, ':'),
                navigationModel = {};

            if (_.endsWith(referenceArray[0], 'UIFormTemplate')) {
                navigationModel = {
                    parentState: 'configuration.formTemplateBrowser',
                    currentState: 'configuration.formEditor.form',
                    data: {
                        uiFormTemplateId: referenceArray[1]
                    }
                };
                $state.go('configuration.formEditor.form', {uiFormTemplateId: referenceArray[1]});
                navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
                $scope.$dismiss();
            }
        };

        $scope.init = function () {
            $scope.viewModel.fieldReferenceList = _.orderBy($scope.viewModel.fieldReferenceList, $scope.viewModel.fieldParams.key, $scope.viewModel.fieldParams.sortType);
        };

        $scope.init();
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('ums.configuration')
    .controller('fieldReferencesController', FieldReferencesController);
